namespace Gamification.Gamification {

    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.registerClass()
    export class ProdottiClassiPickerDialog extends Serenity.TemplatedDialog<ProdottiClassiPickerOptions> {

        private checkGrid: ProdottiClassiCheckGrid;

        constructor(opt: ProdottiClassiPickerOptions) {
            super(opt);

            this.checkGrid = new ProdottiClassiCheckGrid(this.byId("CheckGrid"), opt);
            this.dialogTitle = "Seleziona le classi desiderate";
        }

        protected getTemplate() {
            return `<div id="~_CheckGrid"></div>`;
        }

        protected getDialogButtons() {
            return [
                {
                    text: Q.text("Dialogs.OkButton"),
                    click: () => {
                        var selected = this.checkGrid.selectedItems;
                        if (!selected.length) {
                            Q.notifyWarning("Seleziona almeno un elemento!");
                            return;
                        }

                        if (!this.onSuccess || this.onSuccess(selected))
                            this.dialogClose();
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
        }

        get selectedItems() {
            return this.checkGrid.selectedItems;
        }

        public onSuccess: (selected: Gamification.ProdottiClassiRow[]) => boolean;
    }
}